import React from 'react'
import { Switch, Route } from "react-router-dom"
import UserController from './users/user.controller'
import RoleController from './roles/role.controller'

const SecurityController = () => {
    return (
        <Switch>
            <Route path="/security/roles" component={RoleController} />
            <Route path="/security/users" component={UserController} />
        </Switch>
    )
}

export default SecurityController